var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 44,
    viewBox: "0 0 156 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.805 41.5965L36.1878 41.7578L32.5626 37.8062H13.8235L9.97528 41.3546H2V9.17739L6.90786 2H137.189L152.805 41.5965Z",
    stroke: "url(#paint0_radial_10703_16887)",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.757 36.7602L40.394 36.9214L36.9706 33.2924H15.4441L11.6726 36.5989H5V12.2442L11.9628 6.11523H146.924L154.757 13.6152V36.7602Z",
    fill: "url(#paint1_radial_10703_16887)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.757 36.7602L40.394 36.9214L36.9706 33.2924H15.4441L11.6726 36.5989H5V12.2442L11.9628 6.11523H146.924L154.757 13.6152V36.7602Z",
    fill: "#5453FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10703_16887",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.8252 21.9045) scale(55.603 75.2681)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2328,
    stopColor: "#FFBBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2506,
    stopColor: "#F5B5FF",
    stopOpacity: 0.7844
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3505,
    stopColor: "#C495FF",
    stopOpacity: 0.6967
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4495,
    stopColor: "#9B7AFF",
    stopOpacity: 0.6099
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    stopColor: "#7B66FF",
    stopOpacity: 0.5255
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6382,
    stopColor: "#6457FF",
    stopOpacity: 0.4443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7257,
    stopColor: "#574EFF",
    stopOpacity: 0.3675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#524BFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524BFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10703_16887",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.2778 21.5232) rotate(-0.128408) scale(95.4 40.9591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1205,
    stopColor: "#B84BFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1532,
    stopColor: "#A545FF",
    stopOpacity: 0.7759
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2343,
    stopColor: "#7D36FF",
    stopOpacity: 0.716
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3139,
    stopColor: "#5D2BFF",
    stopOpacity: 0.6572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3906,
    stopColor: "#4623FF",
    stopOpacity: 0.6006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#391FFF",
    stopOpacity: 0.5471
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5268,
    stopColor: "#341DFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8045,
    stopColor: "#524BFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAmount);
export default __webpack_public_path__ + "static/media/bg-amount.aec6b52127c6e2659c0057dc9236bbaa.svg";
export { ForwardRef as ReactComponent };